export const PK = `${process.env.REACT_APP_PK}`;
export const paymentMethodConfigurationForPayment ='pmc_1T79PpAlYZ7jOXt6Tr9XkC7h';
export const paymentMethodConfigurationForSaveMethod ='pmc_1T79QJAlYZ7jOXt6WMLk3mXD';
export const paymentMethodConfigurationForVerification ='pmc_1T79QeAlYZ7jOXt6b9EqPfHZ';
